// calculatorConfigs.ts
// קובץ הגדרות לתצוגת היסטוריית חישובים
// ============================================

// ========== מפת שמות מחשבונים ==========
export const CALCULATOR_NAMES: Record<string, string> = {
    'm1_vehicle': 'M1 בנזין/דיזל/היברידי - ייבוא אישי',
    'm1_electric_private': 'M1 חשמלי - ייבוא אישי',
    'm1_commercial': 'M1 בנזין/דיזל/היברידי - ייבוא מסחרי',
    'M1_vehicle_commercial': 'M1 בנזין/דיזל/היברידי - ייבוא מסחרי',
    'm1_electric_commercial': 'M1 חשמלי - ייבוא מסחרי',
    'n1_tender': 'N1 טנדר - ייבוא אישי',
    'N1_electric_private_import': 'N1 חשמלי - ייבוא אישי',
    'n1_n2_commercial': 'N1 & N2 - ייבוא מסחרי',
    'N1N2_commercial': 'N1 & N2 בנזין/דיזל/היברידי - ייבוא מסחרי',
    'n1_n2_electric_commercial': 'N1 & N2 חשמלי - ייבוא מסחרי',
    'N1_N2_electric_commercial': 'N1 & N2 חשמלי - ייבוא מסחרי',
    'trailer': 'נגררים',
    'trailer_vehicle': 'נגררים',
    'collector_vehicle': 'רכב אספנות',
    'taxi': 'מוניות - ייבוא אישי',
    'taxi_vehicle': 'מוניות - ייבוא אישי',
    'taxi_commercial': 'מוניות - ייבוא מסחרי',
    'taxi_vehicle_commercial': 'מוניות - ייבוא מסחרי',
    'motorcycle': 'אופנועים - ייבוא אישי',
    'motorcycle_vehicle': 'אופנועים - ייבוא אישי',
    'motorcycle_commercial': 'אופנועים - ייבוא מסחרי',
    'jetski': 'אופנוע ים - ייבוא אישי',
    'jet_ski_vehicle': 'אופנוע ים - ייבוא אישי',
    'jetski_commercial': 'אופנוע ים - ייבוא מסחרי',
    'jet_ski_commercial': 'אופנוע ים - ייבוא מסחרי',
};

// ========== מפת שמות מטבעות ==========
export const CURRENCY_NAMES: Record<string, string> = {
    'USD': 'דולר (USD)',
    'EUR': 'אירו (EUR)',
    'GBP': 'לירה שטרלינג (GBP)',
    'JPY': 'ין יפני (JPY)',
    'CHF': 'פרנק שוויצרי (CHF)',
    'AUD': 'דולר אוסטרלי (AUD)',
    'CAD': 'דולר קנדי (CAD)',
};

// ========== מפת מערכות בטיחות M1 ==========
export const SAFETY_SYSTEMS_M1: Record<string, { name: string; points: number }> = {
    'blindSpot': { name: 'מערכת זיהוי כלי רכב ב"שטח מת"', points: 1 },
    'sideCollisionActive': { name: 'מערכת אקטיבית למניעת התנגשות צד ב"שטח מת"', points: 2 },
    'reverseBraking': { name: 'בלימה אוטומטית בנסיעה לאחור', points: 1 },
    'fatigueWarning': { name: 'מערכת התרעה במצב של היסח הדעת הנהג', points: 1 },
    'childAlert': { name: 'מערכת להתרעה על השארת ילדים ברכב', points: 1.5 },
    'doorOpening': { name: 'מערכת אזהרת פתיחת דלת', points: 1.5 },
    'adaptiveLighting': { name: 'מערכת תאורה אדפטיבית/שליטה באורות גבוהים', points: 1 },
    'junctionBraking': { name: 'בלימת חירום להתנעה חוצה בצמתים', points: 1.5 },
};

// ========== מפת מערכות בטיחות אופנועים ==========
export const SAFETY_SYSTEMS_MOTORCYCLE: Record<string, { name: string; discount: number }> = {
    'stability_control': { name: 'מערכת בקרת יציבות', discount: 500 },
    'integrated_braking': { name: 'מערכת בלימה משולבת', discount: 500 },
    'steering_damper': { name: 'משכך היגוי', discount: 500 },
    'traction_control': { name: 'מערכת בקרת משיכה והחלקה', discount: 500 },
    'three_wheeled': { name: 'אופנוע תלת גלגלי', discount: 500 },
};

// ========== פונקציות עזר ==========

// פורמט תאריך מ-YYYY-MM-DD ל-DD.MM.YYYY
export const formatDateDisplay = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
        const parts = dateString.split('-');
        if (parts.length === 3) {
            return `${parts[2]}.${parts[1]}.${parts[0]}`;
        }
        return dateString;
    } catch {
        return dateString;
    }
};

// פורמט תאריך+שעה מלא
export const formatDateTimeDisplay = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hours}:${minutes}`;
    } catch {
        return dateString;
    }
};

// פורמט מספר עם פסיקים (ללא אגורות)
export const formatNumber = (num: number | string | undefined): string => {
    if (num === undefined || num === null) return '0';
    const n = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(n)) return '0';
    return Math.round(n).toLocaleString('he-IL');
};

// פורמט מספר עם אגורות
export const formatNumberWithDecimals = (num: number | string | undefined): string => {
    if (num === undefined || num === null) return '0.00';
    const n = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(n)) return '0.00';
    return n.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// פורמט אחוזים
export const formatPercent = (num: number | string | undefined, decimals: number = 2): string => {
    if (num === undefined || num === null) return '0%';
    const n = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(n)) return '0%';
    return `${n.toFixed(decimals)}%`;
};

// פורמט שער חליפין (4 ספרות)
export const formatExchangeRate = (num: number | string | undefined): string => {
    if (num === undefined || num === null) return '0.0000';
    const n = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(n)) return '0.0000';
    return n.toFixed(4);
};

// ========== טיפוסים ==========
export interface CalculationData {
    id: number;
    calculation_type: string;
    calculation_date: string;
    notes: string;
    input_data: Record<string, any>;
    result_data: Record<string, any>;
    display_info?: {
        calculator_name: string;
        vehicle_price: number;
        currency: string;
        final_cost: number;
        total_taxes: number;
        calculation_date_formatted: string;
    };
}

// ========== פונקציה לחילוץ נתוני M1 בנזין/דיזל ==========
export const extractM1VehicleData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const vehicleInfo = result.vehicle_info || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.systems || {};
    const greenRatingInfo = vehicleInfo.green_rating_info || {};

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה (7%+)',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון',
            greenRatingGroup: input.green_rating_group,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
            roadEntryDate: formatDateDisplay(input.road_entry_date),
            shippingTimeMonths: input.shipping_time_months,
        },

        // === תוצאות חישוב ===
        results: {
            consumerPrice: formatNumber(input.chosen_price || chosenResult.consumer_price_used),
            taxValueIls: formatNumber(baseCalc.tax_value_ils),
            customsFee: formatNumber(baseCalc.customs_fee),
            customsRatePercent: baseCalc.customs_rate_percent || 7,
            purchaseTaxBase: formatNumber(baseCalc.purchase_tax_base),

            // מס יוקרה
            luxuryTaxApplicable: chosenResult.luxury_tax_applicable || false,
            luxuryTaxRate: chosenResult.luxury_tax_rate || 0,

            // מס קניה
            finalPurchaseTax: formatNumber(chosenResult.final_purchase_tax),
            finalPurchaseTaxRate: chosenResult.final_purchase_tax_rate || 0,
            effectivePurchaseTaxRate: chosenResult.effective_purchase_tax_rate || 0,

            // מע"מ
            vatAmount: formatNumber(chosenResult.vat_amount),
            vatRate: 18,

            // סיכום
            totalCost: formatNumber(chosenResult.total_cost),
            monthsOnRoad: chosenResult.months_on_road || 0,
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score || result.safety_level),
            airbagsCount: safetyEquip.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            // M1 דורש מינימום 6 כריות
            minAirbags: 6,
            vehicleType: 'M1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || calc.calculation_type,
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};
// ========== פונקציה לחישוב סך מיסים ==========
export const calculateTotalTaxes = (calc: CalculationData): number => {
    const result = calc.result_data || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || {};
    const finalResults = result.final_results || {};
    const intermediateCalc = result.intermediate_calculations || {};

    // רכב אספנות - מכס נקרא origin_declaration_penalty
    if (intermediateCalc.origin_declaration_penalty !== undefined) {
        const customs = intermediateCalc.origin_declaration_penalty || 0;
        const purchaseTax = finalResults.purchase_tax || 0;
        const vat = finalResults.vat || 0;
        return customs + purchaseTax + vat;
    }

    // נגררים - רק מע"מ, אין מכס ואין מס קניה
    // מזוהה לפי total_value ב-intermediate_calculations (לא total_value_for_customs)
    if (intermediateCalc.total_value !== undefined && finalResults.vat !== undefined && finalResults.total_before_vat !== undefined) {
        const vat = finalResults.vat || 0;
        return vat; // רק מע"מ - אין מכס ואין מס קניה לנגררים
    }


    // מוניות - מבנה ייחודי עם intermediate_calculations + final_results
    if (intermediateCalc.total_value_for_customs !== undefined) {
        const customs = intermediateCalc.customs_fee || 0;
        const purchaseTax = finalResults.purchase_tax_final || 0;
        const vat = finalResults.vat || 0;
        return customs + purchaseTax + vat;
    }

    // מחשבונים עם chosen_result (M1 וכו')
    if (chosenResult.final_purchase_tax !== undefined) {
        const customs = baseCalc.customs_fee || 0;
        const purchaseTax = chosenResult.final_purchase_tax || 0;
        const vat = chosenResult.vat_amount || 0;
        return customs + purchaseTax + vat;
    }

    // מחשבונים עם final_results (נגררים, אופנועים וכו')
    if (finalResults.purchase_tax !== undefined || finalResults.customs_fee !== undefined) {
        const customs = finalResults.customs_fee || 0;
        const purchaseTax = finalResults.purchase_tax || 0;
        const vat = finalResults.vat || finalResults.vat_amount || 0;
        return customs + purchaseTax + vat;
    }

    // אופנוע ים - מבנה עם intermediate_calculations.purchase_tax (לא purchase_tax_final)
    if (intermediateCalc.purchase_tax !== undefined && finalResults.vat !== undefined) {
        const customs = intermediateCalc.customs_fee || 0;
        const purchaseTax = intermediateCalc.purchase_tax || 0;
        const vat = finalResults.vat || 0;
        return customs + purchaseTax + vat;
    }

    // אופנועים - מבנה עם intermediate_calculations.purchase_tax + intermediate_calculations.customs_fee + final_results.vat
    if (intermediateCalc.purchase_tax !== undefined && intermediateCalc.customs_fee !== undefined && finalResults.vat !== undefined) {
        const customs = intermediateCalc.customs_fee || 0;
        const purchaseTax = intermediateCalc.purchase_tax || 0;
        const vat = finalResults.vat || 0;
        return customs + purchaseTax + vat;
    }

    return 0;
};

// ========== פונקציה לחישוב שיעור מיסים ==========
export const calculateTaxRate = (calc: CalculationData): number => {
    const totalTaxes = calculateTotalTaxes(calc);
    const result = calc.result_data || {};
    const baseCalc = result.base_calculations || {};
    const intermediateCalc = result.intermediate_calculations || {};

    // // רכב אספנות - משתמש ב-total_before_customs
    // מוניות - משתמש ב-total_value_for_customs
    const taxValueIls = intermediateCalc.total_before_customs || intermediateCalc.total_value_for_customs || baseCalc.tax_value_ils || 0;
    if (taxValueIls === 0) return 0;

    return (totalTaxes / taxValueIls) * 100;
};
// ========== פונקציה כללית לחילוץ נתונים לפי סוג מחשבון ==========
export const extractCalculationData = (calc: CalculationData) => {
    const calculationType = calc.calculation_type;

    switch (calculationType) {
        case 'm1_vehicle':
            return extractM1VehicleData(calc);

        // === מחשבונים נוספים - יתווספו בהמשך ===
        case 'm1_electric_private':
            return extractM1ElectricPrivateData(calc);

        case 'M1_electric_private_import':
            return extractM1ElectricPrivateData(calc);

        case 'm1_commercial':
            return extractM1CommercialData(calc);

        case 'M1_vehicle_commercial':
            return extractM1CommercialData(calc);

        case 'm1_electric_commercial':
            return extractM1ElectricCommercialData(calc);

        case 'n1_tender':
            return extractN1TenderData(calc);

        case 'N1_electric_private_import':
            return extractN1ElectricPrivateData(calc);

        case 'n1_n2_commercial':
            return extractN1N2CommercialData(calc);

        case 'N1N2_commercial':
            return extractN1N2CommercialData(calc);

        case 'n1_n2_electric_commercial':
            return extractN1N2ElectricCommercialData(calc);

        case 'trailer':
            return extractTrailerData(calc);

        case 'trailer_vehicle':
            return extractTrailerData(calc);

        case 'collector_vehicle':
            return extractCollectorVehicleData(calc);

        case 'taxi':
            return extractTaxiData(calc);

        case 'taxi_vehicle':
            return extractTaxiData(calc);

        case 'taxi_commercial':
        case 'taxi_vehicle_commercial':
            return extractTaxiCommercialData(calc);

        case 'motorcycle':
        case 'motorcycle_vehicle':
            return extractMotorcycleData(calc);

        case 'motorcycle_commercial':
            return extractMotorcycleCommercialData(calc);

        case 'jetski':
            return extractJetskiData(calc);

        case 'jet_ski_vehicle':
            return extractJetskiData(calc);

        case 'jetski_commercial':
            return extractJetskiCommercialData(calc);

        case 'jet_ski_commercial':
            return extractJetskiCommercialData(calc);

        default:
            // fallback - נתונים בסיסיים
            return extractGenericData(calc);
    }
};

// ========== Placeholder functions למחשבונים נוספים ==========
// יתמלאו בהמשך כשנעבוד על כל מחשבון

export const extractM1ElectricPrivateData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const vehicleInfo = result.vehicle_info || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.systems || {};
    const greenRatingInfo = vehicleInfo.green_rating_info || {};

    // זמן הובלה - 0 = "הרכב כבר בארץ"
    const shippingMonths = input.shipping_time_months || vehicleInfo.shipping_time_months || 0;
    const shippingTimeText = shippingMonths === 0 || shippingMonths === '0'
        ? 'הרכב כבר בארץ'
        : `${shippingMonths} חודשים`;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה (7%+)',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון',
            roadEntryDate: formatDateDisplay(input.road_entry_date),
            shippingTimeMonths: shippingMonths,
            shippingTimeText: shippingTimeText,
            // M1 חשמלי - אין ציון ירוק רגיל, יש הנחת חשמלי
            greenRatingGroup: null,
            electricDiscount: greenRatingInfo.discount_amount || -19048,
            electricDiscountDisplay: Math.abs(greenRatingInfo.discount_amount || 19048),
        },

        // === תוצאות חישוב ===
        results: {
            consumerPrice: formatNumber(input.chosen_price || chosenResult.consumer_price_used),
            taxValueIls: formatNumber(baseCalc.tax_value_ils),
            customsFee: formatNumber(baseCalc.customs_fee),
            customsRatePercent: baseCalc.customs_rate_percent || 7,
            purchaseTaxBase: formatNumber(baseCalc.purchase_tax_base),

            // מס יוקרה
            luxuryTaxApplicable: chosenResult.luxury_tax_applicable || false,
            luxuryTaxRate: chosenResult.luxury_tax_rate || 0,

            // מס קניה
            finalPurchaseTax: formatNumber(chosenResult.final_purchase_tax),
            finalPurchaseTaxRate: chosenResult.final_purchase_tax_rate || 0,
            effectivePurchaseTaxRate: chosenResult.effective_purchase_tax_rate || 0,
            chosenCalculationPath: chosenResult.chosen_calculation_path || 1,

            // מע"מ
            vatAmount: formatNumber(chosenResult.vat_amount),
            vatRate: 18,

            // סיכום
            totalCost: formatNumber(chosenResult.total_cost),
            monthsOnRoad: chosenResult.months_on_road || 0,
            shippingTimeMonths: chosenResult.shipping_time_months || shippingMonths,
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score !== undefined || result.safety_level !== undefined || safetyEquip.airbagsCount !== undefined),
            airbagsCount: safetyEquip.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            minAirbags: 6,
            vehicleType: 'M1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'M1 חשמלי - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isElectric: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractM1CommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const luxuryTaxCalc = result.luxury_tax_calculation || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyFeatures = input.safety_features || result.safety_equipment || {};
    const safetySystems = safetyFeatures.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // קטגוריית משקל
    const weightCategory = input.vehicle_weight_category || result.vehicle_weight_category || 'under_3500';
    const weightText =
        weightCategory === 'over_4500' ? 'מעל 4.5 טון' :
        weightCategory === 'between_3500_4500' ? 'בין 3.5-4.5 טון' :
        weightCategory === 'over_3500' ? 'מעל 3.5 טון' :
        'מתחת ל-3.5 טון';

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'כן' : 'לא',
            vehicleWeightCategory: weightCategory,
            weightText: weightText,
            consumerPrice: formatNumberWithDecimals(input.consumer_price || luxuryTaxCalc.price_used),
            greenRatingGroup: input.green_rating_group || greenRatingInfo.group_number,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
        },

        // === תוצאות חישוב ===
        results: {
            // מחיר לצרכן
            consumerPrice: formatNumberWithDecimals(input.consumer_price || luxuryTaxCalc.price_used),

            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_value_for_customs),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || 7,

            // מס קניה בסיסי
            basePurchaseTax: formatNumberWithDecimals(intermediateCalc.base_purchase_tax),
            basePurchaseTaxRatePercent: intermediateCalc.base_purchase_tax_rate_percent || 83,

            // ציון ירוק
            greenRatingApplied: calcInfo.green_rating_applied || greenRatingInfo.applied_adjustment !== undefined,
            greenRatingAdjustment: greenRatingInfo.applied_adjustment || intermediateCalc.green_rating_adjustment || 0,
            greenRatingIsDiscount: greenRatingInfo.is_discount || false,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '',

            // אבזור בטיחותי
            safetyLevel: result.safety_level || intermediateCalc.safety_level || 0,
            safetyDiscount: result.safety_discount || intermediateCalc.safety_discount || 0,

            // מס קניה אחרי הנחות
            purchaseTaxAfterDiscounts: formatNumberWithDecimals(intermediateCalc.purchase_tax_after_discounts),

            // מס יוקרה
            hasLuxuryTax: calcInfo.has_luxury_tax || luxuryTaxCalc.luxury_tax_amount > 0,
            luxuryTaxRate: luxuryTaxCalc.luxury_tax_rate || 0,
            luxuryTaxAmount: luxuryTaxCalc.luxury_tax_amount || 0,

            // מס קניה סופי
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            effectivePurchaseTaxRate: finalResults.effective_purchase_tax_rate || 0,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: (finalResults.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score !== undefined || result.safety_level !== undefined || safetyFeatures.airbagsCount !== undefined),
            airbagsCount: safetyFeatures.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || intermediateCalc.safety_score || 0,
            safetyLevel: result.safety_level || intermediateCalc.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount || intermediateCalc.safety_discount),
            safetyDiscountRaw: result.safety_discount || intermediateCalc.safety_discount || 0,
            minAirbags: 6, // M1 דורש 6 כריות
            vehicleType: 'M1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'M1 בנזין/דיזל/היברידי - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isM1Commercial: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractM1ElectricCommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyFeatures = input.safety_features || {};
    const safetySystems = safetyFeatures.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // קטגוריית משקל
    const weightCategory = input.vehicle_weight_category || calcInfo.vehicle_weight_category || 'under_3500';
    const weightText =
        weightCategory === 'over_4500' ? 'מעל 4.5 טון' :
        weightCategory === 'between_3500_4500' ? 'בין 3.5-4.5 טון' :
        weightCategory === 'over_3500' ? 'מעל 3.5 טון' :
        'מתחת ל-3.5 טון';

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'לא',
            vehicleWeightCategory: weightCategory,
            weightText: weightText,
            consumerPrice: formatNumberWithDecimals(input.consumer_price || calcInfo.consumer_price_used),
            // חשמלי - הנחת ציון ירוק
            greenRatingGroup: greenRatingInfo.group_number || 1,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '1',
            electricDiscount: greenRatingInfo.applied_discount || 19048,
        },

        // === תוצאות חישוב ===
        results: {
            // מחיר לצרכן
            consumerPrice: formatNumberWithDecimals(input.consumer_price || calcInfo.consumer_price_used),

            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_value_for_customs),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || 7,

            // ציון ירוק / הנחת חשמלי
            greenDiscountApplied: intermediateCalc.green_discount_applied || greenRatingInfo.applied_discount || 0,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '1',

            // אבזור בטיחותי
            safetyLevel: intermediateCalc.safety_level || 0,
            safetyDiscount: intermediateCalc.safety_discount || 0,

            // מס יוקרה
            hasLuxuryTax: calcInfo.has_luxury_tax || false,
            luxuryTaxRate: intermediateCalc.luxury_tax_rate_percent || 0,
            luxuryTaxAmount: intermediateCalc.luxury_tax_amount || 0,

            // מס קניה
            purchaseTaxBase: formatNumberWithDecimals(intermediateCalc.purchase_tax_base),
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            purchaseTaxRatePercent: intermediateCalc.purchase_tax_rate_percent || 83,
            effectivePurchaseTaxRate: finalResults.effective_purchase_tax_rate || 0,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: (finalResults.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(intermediateCalc.safety_score !== undefined || intermediateCalc.safety_level !== undefined),
            airbagsCount: safetyFeatures.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: intermediateCalc.safety_score || 0,
            safetyLevel: intermediateCalc.safety_level || 0,
            safetyDiscount: formatNumber(intermediateCalc.safety_discount),
            safetyDiscountRaw: intermediateCalc.safety_discount || 0,
            minAirbags: 6,
            vehicleType: 'M1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'M1 חשמלי - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isElectric: true,
            isCommercial: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractN1TenderData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const vehicleInfo = result.vehicle_info || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || result.final_results || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.systems || {};
    const greenRatingInfo = vehicleInfo.green_rating_info || {};

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה (7%+)',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון',
            greenRatingGroup: input.green_rating_group,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
            roadEntryDate: formatDateDisplay(input.road_entry_date),
            shippingTimeMonths: input.shipping_time_months,
        },

        // === תוצאות חישוב ===
        results: {
            consumerPrice: formatNumber(input.chosen_price || chosenResult.consumer_price_used),
            taxValueIls: formatNumber(baseCalc.tax_value_ils),
            customsFee: formatNumber(baseCalc.customs_fee),
            customsRatePercent: baseCalc.customs_rate_percent || 7,
            purchaseTaxBase: formatNumber(baseCalc.purchase_tax_base),

            // מס יוקרה
            luxuryTaxApplicable: chosenResult.luxury_tax_applicable || false,
            luxuryTaxRate: chosenResult.luxury_tax_rate || 0,
            luxuryTaxAmount: formatNumber(chosenResult.luxury_tax_amount),

            // מס קניה
            finalPurchaseTax: formatNumber(chosenResult.final_purchase_tax),
            basePurchaseTaxRate: chosenResult.base_purchase_tax_rate || 83,
            finalPurchaseTaxRate: chosenResult.final_purchase_tax_rate || 0,
            effectivePurchaseTaxRate: chosenResult.effective_purchase_tax_rate || 0,
            greenDiscountApplied: chosenResult.green_discount_applied || 0,

            // מע"מ
            vatAmount: formatNumber(chosenResult.vat_amount),
            vatRate: 18,

            // סיכום
            totalCost: formatNumber(chosenResult.total_cost),
            monthsOnRoad: chosenResult.months_on_road || 0,
            shippingTimeMonths: chosenResult.shipping_time_months || input.shipping_time_months || 0,
            depreciationRate: chosenResult.depreciation_rate || 0,
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score !== undefined || result.safety_level !== undefined || safetyEquip.airbagsCount !== undefined),
            airbagsCount: safetyEquip.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            // N1 דורש מינימום 4 כריות (לא 6 כמו M1)
            minAirbags: 4,
            vehicleType: 'N1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'N1 טנדר - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isElectric: false,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractN1ElectricPrivateData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const vehicleInfo = result.vehicle_info || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.systems || {};
    const greenRatingInfo = vehicleInfo.green_rating_info || {};

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה (+7%)',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון ✓',
            roadEntryDate: formatDateDisplay(input.road_entry_date),
            shippingTimeMonths: input.shipping_time_months,
            // N1 חשמלי - אין ציון ירוק רגיל, יש הנחת חשמלי
            greenRatingGroup: null, // לא רלוונטי לחשמלי
            electricDiscount: greenRatingInfo.discount_amount || -19048,
        },

        // === תוצאות חישוב ===
        results: {
            consumerPrice: formatNumber(input.chosen_price || chosenResult.consumer_price_used),
            taxValueIls: formatNumber(baseCalc.tax_value_ils),
            customsFee: formatNumber(baseCalc.customs_fee),
            customsRatePercent: baseCalc.customs_rate_percent || 7,
            purchaseTaxBase: formatNumber(baseCalc.purchase_tax_base),

            // מס יוקרה
            luxuryTaxApplicable: chosenResult.luxury_tax_applicable || false,
            luxuryTaxRate: chosenResult.luxury_tax_rate || 0,

            // מס קניה
            finalPurchaseTax: formatNumber(chosenResult.final_purchase_tax),
            finalPurchaseTaxRate: chosenResult.final_purchase_tax_rate || 0,
            effectivePurchaseTaxRate: chosenResult.effective_purchase_tax_rate || 0,

            // מע"מ
            vatAmount: formatNumber(chosenResult.vat_amount),
            vatRate: 18,

            // סיכום
            totalCost: formatNumber(chosenResult.total_cost),
            monthsOnRoad: chosenResult.months_on_road || 0,
            shippingTimeMonths: chosenResult.shipping_time_months || input.shipping_time_months || 0,
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score || result.safety_level),
            airbagsCount: safetyEquip.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            // N1 דורש מינימום 4 כריות (לא 6 כמו M1)
            minAirbags: 4,
            vehicleType: 'N1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'N1 חשמלי - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isElectric: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractN1N2CommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const luxuryTaxCalc = result.luxury_tax_calculation || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyFeatures = input.safety_features || result.safety_equipment || {};
    const safetySystems = safetyFeatures.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // קטגוריית משקל
    const weightCategory = input.vehicle_weight_category || result.vehicle_weight_category || 'under_3500';
    const weightText =
        weightCategory === 'over_4500' ? 'מעל 4.5 טון' :
        weightCategory === 'between_3500_4500' ? 'בין 3.5-4.5 טון' :
        weightCategory === 'over_3500' ? 'מעל 3.5 טון' :
        'מתחת ל-3.5 טון';

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'כן' : 'לא',
            vehicleWeightCategory: weightCategory,
            weightText: weightText,
            consumerPrice: formatNumberWithDecimals(input.consumer_price || calcInfo.consumer_price_used),
            greenRatingGroup: input.green_rating_group || greenRatingInfo.group_number,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
        },

        // === תוצאות חישוב ===
        results: {
            // מחיר לצרכן
            consumerPrice: formatNumberWithDecimals(input.consumer_price || luxuryTaxCalc.price_used),

            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_value_for_customs),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || 7,

            // מס קניה בסיסי
            basePurchaseTax: formatNumberWithDecimals(intermediateCalc.base_purchase_tax),
            basePurchaseTaxRatePercent: intermediateCalc.base_purchase_tax_rate_percent || 83,

            // ציון ירוק
            greenRatingApplied: calcInfo.green_rating_applied || greenRatingInfo.applied_adjustment !== undefined,
            greenRatingAdjustment: greenRatingInfo.applied_adjustment || intermediateCalc.green_rating_adjustment || 0,
            greenRatingIsDiscount: greenRatingInfo.is_discount || false,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '',

            // אבזור בטיחותי
            safetyLevel: result.safety_level || intermediateCalc.safety_level || 0,
            safetyDiscount: result.safety_discount || intermediateCalc.safety_discount || 0,

            // מס קניה אחרי הנחות
            purchaseTaxAfterDiscounts: formatNumberWithDecimals(intermediateCalc.purchase_tax_after_discounts),

            // מס יוקרה
            hasLuxuryTax: calcInfo.has_luxury_tax || luxuryTaxCalc.luxury_tax_amount > 0,
            luxuryTaxRate: luxuryTaxCalc.luxury_tax_rate || 0,
            luxuryTaxAmount: luxuryTaxCalc.luxury_tax_amount || 0,

            // מס קניה סופי
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            effectivePurchaseTaxRate: finalResults.effective_purchase_tax_rate || 0,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: (finalResults.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score !== undefined || result.safety_level !== undefined || safetyFeatures.airbagsCount !== undefined),
            airbagsCount: safetyFeatures.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            minAirbags: 4, // N1/N2 דורש 4 כריות
            vehicleType: 'N1/N2',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'N1 & N2 בנזין/דיזל/היברידי - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isN1N2Commercial: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractN1N2ElectricCommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyFeatures = input.safety_features || {};
    const safetySystems = safetyFeatures.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // קטגוריית משקל
    const weightCategory = input.vehicle_weight_category || calcInfo.vehicle_weight_category || 'under_3500';
    const weightText =
        weightCategory === 'over_4500' ? 'מעל 4.5 טון' :
        weightCategory === 'between_3500_4500' ? 'בין 3.5-4.5 טון' :
        weightCategory === 'over_3500' ? 'מעל 3.5 טון' :
        'מתחת ל-3.5 טון';

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'לא',
            vehicleWeightCategory: weightCategory,
            weightText: weightText,
            consumerPrice: formatNumberWithDecimals(input.consumer_price || calcInfo.consumer_price_used),
            // חשמלי - הנחת ציון ירוק
            greenRatingGroup: greenRatingInfo.group_number || 1,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '1',
            electricDiscount: greenRatingInfo.applied_discount || 19048,
        },

        // === תוצאות חישוב ===
        results: {
            // מחיר לצרכן
            consumerPrice: formatNumberWithDecimals(input.consumer_price || calcInfo.consumer_price_used),

            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_value_for_customs),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || 7,

            // ציון ירוק / הנחת חשמלי
            greenDiscountApplied: intermediateCalc.green_discount_applied || greenRatingInfo.applied_discount || 0,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '1',

            // אבזור בטיחותי
            safetyLevel: intermediateCalc.safety_level || 0,
            safetyDiscount: intermediateCalc.safety_discount || 0,

            // מס יוקרה
            hasLuxuryTax: calcInfo.has_luxury_tax || false,
            luxuryTaxRate: intermediateCalc.luxury_tax_rate_percent || 0,
            luxuryTaxAmount: intermediateCalc.luxury_tax_amount || 0,

            // מס קניה
            purchaseTaxBase: formatNumberWithDecimals(intermediateCalc.purchase_tax_base),
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            purchaseTaxRatePercent: intermediateCalc.purchase_tax_rate_percent || 83,
            effectivePurchaseTaxRate: finalResults.effective_purchase_tax_rate || 0,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: (finalResults.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(intermediateCalc.safety_score !== undefined || intermediateCalc.safety_level !== undefined),
            airbagsCount: safetyFeatures.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: intermediateCalc.safety_score || 0,
            safetyLevel: intermediateCalc.safety_level || 0,
            safetyDiscount: formatNumber(intermediateCalc.safety_discount),
            safetyDiscountRaw: intermediateCalc.safety_discount || 0,
            minAirbags: 4, // N1/N2 דורש 4 כריות
            vehicleType: 'N1/N2',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'N1 & N2 חשמלי - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isElectric: true,
            isCommercial: true,
            isN1N2: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractTrailerData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    // const calcInfo = result.calculation_info || {};

    // נגררים: מכס = 0, מס קניה = 0, רק מע"מ
    const vat = finalResults.vat || 0;
    const totalTaxes = vat; // רק מע"מ

    // חישוב שיעור מיסים - לפי total_value
    const taxValueIls = intermediateCalc.total_value || finalResults.total_before_vat || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: false,
            originDeclarationText: '',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון ✓',
        },

        // === תוצאות חישוב ===
        results: {
            taxValueIls: formatNumber(taxValueIls),
            customsFee: '0',
            customsRatePercent: 0,
            customsExemptionReason: 'פטור',
            finalPurchaseTax: '0',
            purchaseTaxRate: '0%',
            purchaseTaxRateNumber: 0,
            purchaseTaxExemptionReason: 'פטור',
            vatAmount: formatNumber(vat),
            vatRate: 18,
            totalTaxes: formatNumber(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumber(finalResults.final_total),
        },

        // === אבזור בטיחותי - אין בנגררים ===
        safety: {
            hasData: false,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'נגררים',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isTrailer: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractCollectorVehicleData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    // const calcInfo = result.calculation_info || {};

    // חישוב סך מיסים
    // המכס נקרא origin_declaration_penalty במבנה הזה
    const customsFee = intermediateCalc.origin_declaration_penalty || 0;
    const purchaseTax = finalResults.purchase_tax || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים - לפי total_before_customs
    const taxValueIls = intermediateCalc.total_before_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה (7%+)',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון ✓',
        },

        // === תוצאות חישוב ===
        results: {
            // ערך לצורכי מכס = total_before_customs
            taxValueIls: formatNumber(intermediateCalc.total_before_customs),

            // מכס = origin_declaration_penalty
            customsFee: formatNumber(customsFee),
            customsRatePercent: input.has_origin_declaration ? 0 : 7,

            // מס קניה
            finalPurchaseTax: formatNumber(purchaseTax),
            purchaseTaxRate: '72%',
            purchaseTaxRateNumber: 72,

            // מע"מ
            vatAmount: formatNumber(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumber(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumber(finalResults.final_total),
        },

        // === אבזור בטיחותי - אין ברכב אספנות ===
        safety: {
            hasData: false,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'רכב אספנות',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isCollector: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractTaxiData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: '',
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: input.insurance_cost_foreign === 0 ? 'ללא ביטוח' : formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            engineType: input.engine_type || calcInfo.engine_type || '',
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה',
            vehicleWeightOver3500: input.vehicle_weight_over_3500,
            weightText: input.vehicle_weight_over_3500 ? 'מעל 3.5 טון' : 'עד 3.5 טון ✓',
            greenRatingGroup: input.green_rating_group,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
        },

        // === תוצאות חישוב ===
        results: {
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_value_for_customs),
            customsFee: formatNumber(intermediateCalc.customs_fee),
            customsRatePercent: intermediateCalc.customs_fee === 0 ? 0 : 7,
            customsExemptionReason: calcInfo.customs_exemption_reason || '',

            purchaseTaxBeforeGreen: formatNumberWithDecimals(intermediateCalc.purchase_tax_before_green),
            finalPurchaseTax: formatNumberWithDecimals(finalResults.purchase_tax_final),
            purchaseTaxRate: calcInfo.purchase_tax_rate || '8%',
            purchaseTaxRateNumber: 8,

            greenRatingApplied: calcInfo.green_rating_applied || false,
            greenRatingAdjustment: greenRatingInfo.applied_adjustment || 0,
            greenRatingIsDiscount: greenRatingInfo.is_discount || false,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '',

            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(finalResults.vat),
            vatRate: 18,

            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),

        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(result.safety_score !== undefined || result.safety_level !== undefined || safetyEquip.airbagsCount !== undefined),
            airbagsCount: safetyEquip.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: result.safety_score || 0,
            safetyLevel: result.safety_level || 0,
            safetyDiscount: formatNumber(result.safety_discount),
            safetyDiscountRaw: result.safety_discount || 0,
            minAirbags: 6,
            vehicleType: 'מונית',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'מוניות - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isTaxi: true,
            engineType: input.engine_type || calcInfo.engine_type || '',
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractTaxiCommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const greenRatingInfo = intermediateCalc.green_rating_info || {};
    const safetyEquip = result.safety_equipment || {};
    const safetySystems = safetyEquip.features?.systems || safetyEquip.systems || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = finalResults.purchase_tax_final || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: input.insurance_cost_foreign === 0 ? 'ללא ביטוח' : formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            engineType: input.engine_type || calcInfo.engine_type || '',
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? '✅ יש' : '❌ אין',
            vehicleWeightOver3500: input.vehicle_weight_over_3500 || input.is_heavy_vehicle,
            weightText: (input.vehicle_weight_over_3500 || input.is_heavy_vehicle) ? 'מעל 3.5 טון' : 'עד 3.5 טון',
            greenRatingGroup: input.green_rating_group,
            greenRatingDisplayName: greenRatingInfo.group_display_name || input.green_rating_group,
        },

        // === תוצאות חישוב ===
        results: {
            taxValueIls: formatNumber(intermediateCalc.total_value_for_customs),
            customsFee: formatNumber(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || (customsFee === 0 ? 0 : 7),
            customsExemptionReason: calcInfo.customs_exemption_reason || '',

            // מס קניה לפני התאמות
            purchaseTaxBeforeAdjustments: formatNumber(intermediateCalc.purchase_tax_before_adjustments),

            // הנחת ציון ירוק
            greenRatingApplied: calcInfo.green_rating_applied || greenRatingInfo.applied_adjustment !== undefined,
            greenRatingAdjustment: greenRatingInfo.applied_adjustment || 0,
            greenRatingIsDiscount: greenRatingInfo.is_discount || false,
            greenRatingDisplayName: greenRatingInfo.group_display_name || '',

            // הנחת אבזור בטיחותי
            safetyDiscountApplied: calcInfo.safety_discount_applied || false,
            safetyDiscountAmount: safetyEquip.discount_amount || 0,

            // מס קניה סופי
            finalPurchaseTax: formatNumber(purchaseTax),
            purchaseTaxRate: calcInfo.purchase_tax_rate || '8%',
            purchaseTaxRateNumber: calcInfo.purchase_tax_rate_percent || 8,
            effectivePurchaseTaxRate: intermediateCalc.effective_purchase_tax_rate || 0,

            // מע"מ
            vatBase: formatNumber(finalResults.vat_base),
            vatAmount: formatNumber(vat),
            vatRate: 18,

            // סיכום
            totalTaxes: formatNumber(totalTaxes),
            taxRatePercent: (finalResults.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumber(finalResults.final_total),
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: !!(safetyEquip.safety_score !== undefined || safetyEquip.safety_level !== undefined || safetyEquip.features?.airbagsCount !== undefined),
            airbagsCount: safetyEquip.features?.airbagsCount || 0,
            systems: safetySystems,
            safetyScore: safetyEquip.safety_score || 0,
            safetyLevel: safetyEquip.safety_level || 0,
            safetyDiscount: formatNumber(safetyEquip.discount_amount),
            safetyDiscountRaw: safetyEquip.discount_amount || 0,
            isEligible: safetyEquip.is_eligible || false,
            minAirbags: 6,
            vehicleType: 'M1',
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'מוניות - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isTaxiCommercial: true,
            engineType: input.engine_type || calcInfo.engine_type || '',
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractMotorcycleData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const engineInfo = intermediateCalc.engine_info || {};
    const safetyFeatures = result.safety_features || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = intermediateCalc.purchase_tax || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים - לפי total_before_customs
    const taxValueIls = intermediateCalc.total_before_customs || intermediateCalc.base_value_before_taxes || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // המרת engine_capacity לתצוגה
    const getEngineTypeDisplay = (capacity: string | number): string => {
        const cap = typeof capacity === 'string' ? parseInt(capacity) : capacity;
        if (!cap || isNaN(cap)) return '';
        if (cap <= 500) return 'עד 500 סמ"ק';
        if (cap <= 800) return 'עולה על 500 סמ"ק אך אינו עולה על 800 סמ"ק';
        return 'עולה על 800 סמ"ק';
    };

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה (פטור ממכס)' : 'אין הצהרה',
            // סוג מנוע לאופנועים
            engineCapacity: input.engine_capacity || engineInfo.capacity_cc,
            engineTypeDisplay: engineInfo.capacity_group || getEngineTypeDisplay(input.engine_capacity),
            isElectric: input.is_electric || false,
        },

        // === תוצאות חישוב ===
        results: {
            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_before_customs || intermediateCalc.base_value_before_taxes),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || (input.has_origin_declaration ? 0 : 7),

            // מס קניה
            purchaseTaxBase: formatNumberWithDecimals(intermediateCalc.purchase_tax_base),
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            purchaseTaxRate: `${engineInfo.tax_rate_percent || calcInfo.purchase_tax_rate_percent || 60}%`,
            purchaseTaxRateNumber: engineInfo.tax_rate_percent || calcInfo.purchase_tax_rate_percent || 60,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: calcInfo.vat_rate_percent || 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),

            // הנחת אבזור בטיחותי
            safetyDiscount: result.calculated_safety_discount || 0,
            finalTotalWithDiscount: formatNumberWithDecimals(result.final_total_with_discount),
        },

        // === אבזור בטיחותי - ייחודי לאופנועים ===
        safety: {
            hasData: calcInfo.safety_features_eligible || Object.keys(safetyFeatures).length > 0,
            features: safetyFeatures,
            calculatedDiscount: result.calculated_safety_discount || 0,
            finalTotalWithDiscount: result.final_total_with_discount || 0,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'אופנועים - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isMotorcycle: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.actual_cost_data ? {
            hasData: true,
            ...result.actual_cost_data,
        } : { hasData: false },
    };
};

export const extractMotorcycleCommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};
    const engineInfo = intermediateCalc.engine_info || {};
    const safetyEquip = result.safety_equipment || {};
    const safetyFeatures = safetyEquip.features || input.safety_features || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = intermediateCalc.purchase_tax || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים - לפי total_before_customs
    const taxValueIls = intermediateCalc.total_before_customs || intermediateCalc.base_value_before_taxes || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    // המרת engine_capacity לתצוגה
    const getEngineTypeDisplay = (capacity: string | number): string => {
        const cap = typeof capacity === 'string' ? parseInt(capacity) : capacity;
        if (!cap || isNaN(cap)) return '';
        if (cap <= 500) return 'עד 500 סמ"ק';
        if (cap <= 800) return 'עולה על 500 סמ"ק אך אינו עולה על 800 סמ"ק';
        return 'עולה על 800 סמ"ק';
    };

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? '✅ יש' : '❌ אין',
            // סוג מנוע לאופנועים
            engineCapacity: input.engine_capacity || engineInfo.capacity_cc,
            engineTypeDisplay: engineInfo.capacity_group || getEngineTypeDisplay(input.engine_capacity),
            isElectric: input.is_electric || engineInfo.is_electric || false,
        },

        // === תוצאות חישוב ===
        results: {
            // ערך לצורכי מכס
            taxValueIls: formatNumberWithDecimals(intermediateCalc.total_before_customs || intermediateCalc.base_value_before_taxes),

            // מכס
            customsFee: formatNumberWithDecimals(customsFee),
            customsRatePercent: intermediateCalc.customs_rate_percent || (input.has_origin_declaration ? 0 : 7),

            // מס קניה לפני הנחה
            purchaseTaxBeforeDiscount: formatNumberWithDecimals(intermediateCalc.purchase_tax_before_discount),

            // הנחת אבזור בטיחותי
            safetyDiscountAmount: safetyEquip.discount_amount || 0,
            safetyDiscountApplied: calcInfo.safety_discount_applied || safetyEquip.is_eligible || false,

            // מס קניה סופי (אחרי הנחה)
            finalPurchaseTax: formatNumberWithDecimals(purchaseTax),
            purchaseTaxRate: `${engineInfo.tax_rate_percent || calcInfo.purchase_tax_rate_percent || 60}%`,
            purchaseTaxRateNumber: engineInfo.tax_rate_percent || calcInfo.purchase_tax_rate_percent || 60,

            // מע"מ
            vatBase: formatNumberWithDecimals(finalResults.vat_base),
            vatAmount: formatNumberWithDecimals(vat),
            vatRate: calcInfo.vat_rate_percent || 18,

            // סיכום
            totalTaxes: formatNumberWithDecimals(totalTaxes),
            taxRatePercent: (intermediateCalc.tax_percentage || taxRate).toFixed(1),
            totalCost: formatNumberWithDecimals(finalResults.final_total),

            // חיסכון
            totalSavingsFromSafety: finalResults.total_savings_from_safety || 0,
        },

        // === אבזור בטיחותי ===
        safety: {
            hasData: Object.keys(safetyFeatures).length > 0 || safetyEquip.discount_amount > 0,
            features: safetyFeatures,
            discountAmount: safetyEquip.discount_amount || 0,
            isEligible: safetyEquip.is_eligible || false,
            appliedToPurchaseTax: safetyEquip.applied_to_purchase_tax || false,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'אופנועים - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isMotorcycleCommercial: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

export const extractJetskiData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = intermediateCalc.purchase_tax || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'EUR',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה' : 'אין הצהרה',
        },

        // === תוצאות חישוב ===
        results: {
            taxValueIls: formatNumber(intermediateCalc.total_value_for_customs),
            customsFee: formatNumber(intermediateCalc.customs_fee),
            customsRatePercent: 0, // אופנועי ים פטורים ממכס!
            customsExemptionReason: calcInfo.customs_exemption_reason || 'פטור ממכס - אופנועי ים',

            purchaseTaxBase: formatNumber(intermediateCalc.purchase_tax_base),
            finalPurchaseTax: formatNumber(intermediateCalc.purchase_tax),
            purchaseTaxRate: calcInfo.purchase_tax_rate || '20%',
            purchaseTaxRateNumber: 20,

            vatBase: formatNumber(finalResults.vat_base),
            vatAmount: formatNumber(finalResults.vat),
            vatRate: 18,

            totalTaxes: formatNumber(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumber(finalResults.final_total),
        },

        // === אבזור בטיחותי - אין באופנוע ים ===
        safety: {
            hasData: false,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'אופנוע ים - ייבוא אישי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isJetski: true,
        },
    };
};

export const extractJetskiCommercialData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const intermediateCalc = result.intermediate_calculations || {};
    const finalResults = result.final_results || {};
    const calcInfo = result.calculation_info || {};

    // חישוב סך מיסים
    const customsFee = intermediateCalc.customs_fee || 0;
    const purchaseTax = intermediateCalc.purchase_tax || 0;
    const vat = finalResults.vat || 0;
    const totalTaxes = customsFee + purchaseTax + vat;

    // חישוב שיעור מיסים
    const taxValueIls = intermediateCalc.total_value_for_customs || 0;
    const taxRate = taxValueIls > 0 ? (totalTaxes / taxValueIls) * 100 : 0;

    return {
        // === נתוני קלט ===
        input: {
            manufacturingDate: formatDateDisplay(input.manufacturing_date),
            vehiclePrice: formatNumber(input.vehicle_price_foreign),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type,
            exchangeRate: formatExchangeRate(input.exchange_rate),
            shippingCost: formatNumber(input.shipping_cost_foreign),
            insuranceCost: formatNumber(input.insurance_cost_foreign),
            insuranceExchangeRate: formatExchangeRate(input.insurance_exchange_rate),
            localExpenses: formatNumber(input.local_expenses_ils),
            hasOriginDeclaration: input.has_origin_declaration,
            originDeclarationText: input.has_origin_declaration ? 'יש הצהרה' : 'אין הצהרה',
        },

        // === תוצאות חישוב ===
        results: {
            taxValueIls: formatNumber(intermediateCalc.total_value_for_customs),
            customsFee: formatNumber(customsFee),
            customsRatePercent: 0,
            customsExemptionReason: calcInfo.customs_exemption_reason || 'פטור ממכס - אופנועי ים',

            purchaseTaxBase: formatNumber(intermediateCalc.purchase_tax_base),
            finalPurchaseTax: formatNumber(purchaseTax),
            purchaseTaxRate: calcInfo.purchase_tax_rate || '20%',
            purchaseTaxRateNumber: 20,

            vatBase: formatNumber(finalResults.vat_base),
            vatAmount: formatNumber(vat),
            vatRate: 18,

            totalTaxes: formatNumber(totalTaxes),
            taxRatePercent: taxRate.toFixed(1),
            totalCost: formatNumber(finalResults.final_total),
        },

        // === אבזור בטיחותי - אין באופנוע ים ===
        safety: {
            hasData: false,
        },

        // === מידע כללי ===
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || 'אופנוע ים - ייבוא מסחרי',
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
            isJetskiCommercial: true,
        },

        // === נתוני "דייק לי את התוצאה" ===
        actualCost: result.commercial_actual_cost_data ? {
            hasData: true,
            ...result.commercial_actual_cost_data,
        } : { hasData: false },
    };
};

// ========== פונקציית Fallback גנרית ==========
export const extractGenericData = (calc: CalculationData) => {
    const input = calc.input_data || {};
    const result = calc.result_data || {};
    const baseCalc = result.base_calculations || {};
    const chosenResult = result.chosen_result || {};
    const finalResults = result.final_results || {};

    return {
        input: {
            vehiclePrice: formatNumber(input.vehicle_price_foreign || input.vehicle_price),
            currency: input.currency_type || 'USD',
            currencyName: CURRENCY_NAMES[input.currency_type] || input.currency_type || 'USD',
            exchangeRate: formatExchangeRate(input.exchange_rate),
        },
        results: {
            customsFee: formatNumber(baseCalc.customs_fee || finalResults.customs_fee || 0),
            purchaseTax: formatNumber(chosenResult.final_purchase_tax || finalResults.purchase_tax || 0),
            vatAmount: formatNumber(chosenResult.vat_amount || finalResults.vat || 0),
            totalCost: formatNumber(chosenResult.total_cost || finalResults.total_cost || 0),
        },
        safety: {
            hasData: false,
        },
        meta: {
            calculatorName: CALCULATOR_NAMES[calc.calculation_type] || calc.calculation_type,
            calculationDate: formatDateTimeDisplay(calc.calculation_date),
            notes: calc.notes || '',
        },
    };
};

// ========== בדיקה אם מחשבון תומך באבזור בטיחותי ==========
export const hasSafetyEquipment = (calculationType: string): boolean => {
    const typesWithSafety = [
        'm1_vehicle',
        'm1_electric_private',
        'm1_commercial',
        'm1_electric_commercial',
        'n1_tender',
        'n1_electric_private',
        'taxi',
        'taxi_commercial',
        'motorcycle_commercial',
    ];
    return typesWithSafety.includes(calculationType);
};

// ========== קבלת רשימת מערכות בטיחות פעילות ==========
export const getActiveSafetySystems = (
    systems: Record<string, boolean>,
    systemsMap: Record<string, { name: string; points: number }>
): Array<{ key: string; name: string; points: number }> => {
    const activeSystems: Array<{ key: string; name: string; points: number }> = [];

    for (const [key, isActive] of Object.entries(systems)) {
        if (isActive && systemsMap[key]) {
            activeSystems.push({
                key,
                name: systemsMap[key].name,
                points: systemsMap[key].points,
            });
        }
    }

    return activeSystems;
};